/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/datatypes';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "UpsertCatalogObjectRequest": {
                        "fields": {
                          "idempotencyKey": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "object": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpsertCatalogObjectResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "catalogObject": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "optional"
                          },
                          "idMappings": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogIdMapping",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpsertCatalogObjectRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpsertCatalogObjectResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpsertCatalogObjectRequest @ squareup/connect/v2/catalog/interfaces/upsert-catalog-object.proto at 19:1
 */
export const UpsertCatalogObjectRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpsertCatalogObjectRequest');
fixType(UpsertCatalogObjectRequest, {
  idempotencyKey: {
    required: true,
    notEmpty: true
  },
  object: {
    required: true
  }
});
Builder.createAndAttachToType(UpsertCatalogObjectRequest);
/**
 * SOURCE UpsertCatalogObjectResponse @ squareup/connect/v2/catalog/interfaces/upsert-catalog-object.proto at 52:1
 */
export const UpsertCatalogObjectResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpsertCatalogObjectResponse');
fixType(UpsertCatalogObjectResponse);
Builder.createAndAttachToType(UpsertCatalogObjectResponse);